import { PREDICTION_WINDOW_MS } from '@pons/contracts';

/** Figma 3156:2412. The mode switch uses the same feed state as the header. */
export function LiveArenaEmpty({
  ready,
  onGame,
  gameSelected = false,
}: {
  ready: boolean;
  onGame: () => void;
  gameSelected?: boolean;
}) {
  return (
    <div className="live-arena-empty">
      <div className="live-empty-copy" role="status">
        <h2>
          {ready ? (
            <>
              Waiting
              <br />
              for a graduation
            </>
          ) : (
            'Loading the arena…'
          )}
        </h2>
        <p>
          New Pons tokens appear here automatically.
          <br />
          You get {PREDICTION_WINDOW_MS / 1000} seconds from graduation to make
          your call.
        </p>
      </div>
      <img
        className="live-empty-divider"
        src="/images/live-empty-divider.svg"
        width="603"
        height="1"
        alt=""
      />
      <div className="live-empty-game">
        <button
          className="live-empty-switch"
          type="button"
          role="switch"
          aria-checked={gameSelected}
          aria-label="Game Mode"
          aria-describedby="live-empty-game-description"
          onClick={onGame}
        >
          <span className={gameSelected ? '' : 'is-active'}>live</span>
          <span className="live-empty-switch-track" aria-hidden="true">
            <img src="/images/rail-dot-run.svg" width="22" height="22" alt="" />
          </span>
          <span className={gameSelected ? 'is-active' : ''}>game</span>
        </button>
        <p id="live-empty-game-description">
          Have some fun in Game Mode while you wait for tokens to appear on the
          Pons.
        </p>
      </div>
    </div>
  );
}
